// src/autodesk_usage/hooks/useCorporateList.ts
// All comments in English only
import { useQuery } from "@tanstack/react-query";
import { getCorporateList, type CorporateItem } from "../api/corporate";

export interface UseCorporateListResult {
  data?: CorporateItem[];
  isLoading: boolean;
  error: unknown;
}

function normalizeCorporatePayload(payload: unknown): CorporateItem[] {
  if (Array.isArray(payload)) {
    return payload as CorporateItem[];
  }
  if (
    payload &&
    typeof payload === "object" &&
    Array.isArray((payload as any).items)
  ) {
    return (payload as any).items as CorporateItem[];
  }
  return [];
}

export function useCorporateList(): UseCorporateListResult {
  const query = useQuery<CorporateItem[]>({
    queryKey: ["corporate-list"],
    queryFn: async () => {
      const res = await getCorporateList();
      return normalizeCorporatePayload(res.data);
    },
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
